import { render } from "./product-addons-drawer.vue?vue&type=template&id=ff64caf6"
import script from "./product-addons-drawer.vue?vue&type=script&lang=js"
export * from "./product-addons-drawer.vue?vue&type=script&lang=js"

import "./product-addons-drawer.vue?vue&type=style&index=0&id=ff64caf6&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__